import React from 'react'
import { Box, Card, CardMedia, IconButton, TextField, Typography } from '@mui/material'
import { useStyles } from './style'
import { DeleteForever } from '@mui/icons-material'

const ImageDisplay = ({ imageInfo, setImageInfo }) => {
  const classes = useStyles()
  const [hover, setHover] = React.useState(false)
  const { altText, stock, author } = imageInfo
  const defaultValues = {
    imgUrl: '',
    s3Url: '',
    altText: '',
    stock: '',
    author: ''
  }

  const handleChangeAlt = (value) => {
    setImageInfo({ ...imageInfo, altText: value })
  }

  const handleChangeStock = (value) => {
    setImageInfo({ ...imageInfo, stock: value })
  }

  const handleChangeAuthor = (value) => {
    setImageInfo({ ...imageInfo, author: value })
  }

  return (
    <Box display='flex' mb={2}>
      <Card
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        className={classes.imageContainer}
      >
        <CardMedia
          component='img'
          height={220}
          width={392}
          image={imageInfo.imgUrl}
          alt={imageInfo.altText}
          data-test='image-display'
        />
        <IconButton
          className={classes.buttonContainer}
          aria-label='delete'
          style={{
            display: hover ? 'flex' : 'none',
            backgroundColor: 'rgba(255, 255, 255, 0.9)'
          }}
          onClick={() => setImageInfo({
            ...defaultValues
          })}
          data-test='image-display-delete-button'
        >
          <DeleteForever
            color='error'
            fontSize='large'
          />
        </IconButton>
      </Card>
      <Box display='flex' flexDirection='column' className={classes.infoContainer}>
        <TextField
          fullWidth
          value={altText}
          variant='outlined'
          placeholder='Alt text'
          label='Alt text'
          helperText={
            <div
              className={classes.helperText}
              data-test='image-display-alt-helper'
            >
              The Text Alt describes the appearance and function of the image and will be displayed only if the image file cannot be loaded. It's important for accessibility purposes.
            </div>
          }
          onChange={ev => handleChangeAlt(ev.target.value)}
          data-test='image-display-alt'
        />
        <Box display='flex' flexDirection='column' className={classes.copyrightContainer}>
          <Typography variant='h6'>
            Copyright
          </Typography>
          <Box display='flex' flexDirection='row' gap={2} className={classes.copyrightContainer}>
            <TextField
              fullWidth
              value={stock}
              variant='outlined'
              placeholder='Stock Photos'
              label='Stock Photos'
              onChange={ev => handleChangeStock(ev.target.value)}
              data-test='image-display-stock'
            />
            <TextField
              fullWidth
              value={author}
              variant='outlined'
              placeholder='Add Author'
              label='Author'
              onChange={ev => handleChangeAuthor(ev.target.value)}
              data-test='image-display-author'
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default ImageDisplay
